import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, SafeAreaView } from 'react-native';
import i18n from 'i18n-js';

const baseHeight = 56;

const wallboardLevelNames = {
  live: 'Live',
  today: 'Timeline Today',
  last24: 'Timeline Last 24 Hours',
};

export const WallboardLevel = ({ C, triggerWallboardLevel, wallboardSelectedLevel = 'live', setWallboardSelectedLevel, Svg, font }) => {
  const levels = [
    { value: 'live', text: 'Live' },
    { value: 'today', text: 'Timeline Today' },
    { value: 'last24', text: 'Timeline Last 24 Hours' },
  ];

  return (
    <TouchableOpacity
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: C('Overlay/Light/Dim strong'),
        position: 'absolute',
        zIndex: 1000000000,
      }}
      onPress={() => triggerWallboardLevel()}
      activeOpacity={1}
    >
      <View
        style={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
        }}
      >
        <View
          style={{
            width: 298,
            height: levels.length * 41,
            marginTop: 54,
            alignItems: 'center',
          }}
        >
          {levels.map((i, index) => {
            const isFirst = index == 0;
            const isLast = index == levels.length - 1;
            return (
              <TouchableOpacity
                onPress={() => {
                  setWallboardSelectedLevel(i.value);
                  // logError(`User change wallboard level to: ${i.text}`, { item: i }, 'Debug');
                  triggerWallboardLevel();
                }}
                key={i.value}
              >
                <View
                  style={[
                    {
                      width: 298,
                      height: 41,
                      borderBottomColor: C('Hairline/Light/No trans'),
                      borderBottomWidth: isLast ? 0 : StyleSheet.hairlineWidth,
                      backgroundColor: C('Background/Light/Field'),
                      flexDirection: 'row',
                      alignItems: 'center',
                    },
                    isFirst && {
                      borderTopLeftRadius: 12,
                      borderTopRightRadius: 12,
                    },
                    isLast && {
                      borderBottomLeftRadius: 12,
                      borderBottomRightRadius: 12,
                    },
                  ]}
                >
                  <View style={{ marginLeft: 10, marginRight: 6, opacity: wallboardSelectedLevel == i.value ? 1 : 0 }}>
                    <Svg icon="check" width={14} height={14} color="Label/Light/Primary" />
                  </View>
                  <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>{i18n.t(i.text)}</Text>
                </View>
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default (props) => {
  const { C, navigateBack, Svg, isIOS, isChromeOS, font, frameScaleFactor, wallboardSelectedLevel, wallboardLevel, triggerWallboardLevel, isWeb } =
    props;

  const scale = (v) => v * frameScaleFactor;
  const getPadding = () => {
    if (isIOS) {
      return 0;
    }
    if (isChromeOS) {
      return scale(15);
    }
    return 0;
  };

  const margin = 0;
  const padding = getPadding();

  return [
    <SafeAreaView style={{ position: 'absolute', zIndex: 50, width: '100%' }} key="backHeader">
      <View
        key="machineDetailsHeader"
        style={{
          zIndex: 50,
          width: '100%',
          height: baseHeight,
          top: 0,
          backgroundColor: C('Background/Light/System'),
        }}
      >
        <View
          style={{
            height: baseHeight,
            marginTop: margin,
            paddingTop: padding,
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: scale(14),
            backgroundColor: C('Background/Light/Chart'),
          }}
        >
          <TouchableOpacity onPress={navigateBack} hitSlop={{ top: 20, left: 20, right: 20, bottom: 20 }}>
            <View>
              <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
            </View>
          </TouchableOpacity>
          <View style={{}}>
            <TouchableOpacity onPress={() => triggerWallboardLevel(!wallboardLevel)} activeOpacity={1}>
              <View
                style={[
                  {
                    backgroundColor: C(wallboardLevel ? 'Button/Light/Disabled' : 'Selected/Light/Primary'),
                    borderRadius: 18,
                    flexDirection: 'row',
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                  },
                  isWeb && {
                    userSelect: 'none',
                  },
                ]}
              >
                <Text
                  style={[
                    font['Footnote'],
                    {
                      color: C(wallboardLevel ? 'Label/Light/Quinary' : 'Button/Light/Primary Text'),
                      marginRight: 10,
                      fontSize: 15,
                      fontWeight: '500',
                    },
                  ]}
                >
                  {i18n.t(wallboardLevelNames[wallboardSelectedLevel || 'live'])}
                </Text>
                <Svg
                  key={`chevronBottomLight-${wallboardLevel}`}
                  icon="chevronBottomLight"
                  width={15}
                  height={17}
                  color={wallboardLevel ? 'Label/Light/Quinary' : 'Button/Light/Primary Text'}
                />
              </View>
            </TouchableOpacity>
          </View>
          <View />
        </View>
      </View>
    </SafeAreaView>,
    wallboardLevel && <WallboardLevel {...props} key="WallboardLevelSelect" />,
  ];
};
